export default __webpack_public_path__ + "static/eco_packaging_black-bdb3699ab5d7c5869184faf90a31cbdb.svg";